import * as Yup from 'yup';
import { TFunction } from 'i18next';
import Select from '@lib/components/Select/Select';
import { FieldItem } from '@lib/interfaces/form';
import { getOptionShape } from '@lib/utils/validationUtils';
import UserFieldNames from '@lib/enums/fieldNames/userFieldNames';
import { langOptions } from '@lib/utils/lang';
import styles from '../components/ProfileForm.module.scss';

type LangFormFieldsArgs = {
  t: TFunction<'translation', undefined>;
  loading: boolean;
};

export default function getLangFormFields({
  t,
  loading,
}: LangFormFieldsArgs): FieldItem[] {
  return [
    {
      name: UserFieldNames.Lang,
      label: t('choose-language'),
      element: Select,
      validation: Yup.object()
        .shape(getOptionShape(t, true))
        .required(t('required-field-error')),
      formItemClassName: styles.column,
      componentProps: {
        disabled: loading,
        options: langOptions,
        isClearable: false,
        menuPlacement: 'top',
      },
    },
  ];
}
